import api from './api';

export const createPost = (data) => {
  // data includes: title, content, postDate, tags (JSON), and optionally photos (FormData)
  const formData = new FormData();
  formData.append('title', data.title);
  formData.append('content', data.content);
  formData.append('postDate', data.postDate);
  if (data.tags && data.tags.length > 0) {
    formData.append('tags', JSON.stringify(data.tags));
  }
  if (data.photos && data.photos.length > 0) {
    data.photos.forEach((photo) => {
      formData.append('photos', photo);
    });
  }
  return api.post('/api/training-journal', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const listPosts = (filters = {}) =>
  api.get('/api/training-journal', { params: filters });

export const getPost = (id) => api.get(`/api/training-journal/${id}`);

export const updatePost = (id, data) => {
  const formData = new FormData();
  if (data.title !== undefined) formData.append('title', data.title);
  if (data.content !== undefined) formData.append('content', data.content);
  if (data.postDate !== undefined) formData.append('postDate', data.postDate);
  if (data.tags !== undefined) {
    formData.append('tags', JSON.stringify(data.tags));
  }
  if (data.newPhotos && data.newPhotos.length > 0) {
    data.newPhotos.forEach((photo) => {
      formData.append('photos', photo);
    });
  }
  return api.patch(`/api/training-journal/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deletePost = (id) => api.delete(`/api/training-journal/${id}`);
